import moment from 'moment'

export default (pDateString) => {
  if (moment(pDateString, 'DD/MM/YYYY').isValid()) return pDateString
  if (!moment(pDateString).isValid()) return '--/--/----'
  return moment(pDateString).format('DD/MM/YYYY')
}



// WEBPACK FOOTER //
// ./src/components/primitives/helpers/filters/DateBR.js